
// TODO: AÑADIR LOGO VER COMO VA EN EL SERVICIO
import Typography from '@library/components/Atoms/Typography/Typography.vue'
import Imagen from '@library/components/Atoms/Image/Image.vue'
import NavigationColumns from '@library/components/Molecules/Header/NavigationColumns.vue'

export default {
  name: 'SideNavSecondary',
  components: {Typography, Imagen, NavigationColumns},
  data: () => ({
    akamaiCutting: '?output-quality=70&resize=135:*&composite-to=center,center|135:26&background-color=white'
  }),
  props: {
    navigationList: {
      type: Object,
      required: false,
      default: () => {}
    },
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    isOpenSubMenuItem: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    logo() {
      return this.navigationList?.content?.logo?.url || ''
    },
    logoTitle() {
      return this.navigationList?.content?.logoText?.content?.title || ''
    },
    logoAlt() {
      return this.navigationList?.content?.logoText?.content?.alt || ''
    }
  },
  methods: {
    filterObject(key) {
      const content = this.navigationList?.content
      const texts = {
        textTitle: () => content?.text?.title || '',
        textBody: () => content?.text?.body || '',
        linkHref: () => (content?.link ? content?.link?.linkUrl || content?.link?.urlExterna : ''),
        linkTarget: () => (content?.link && content?.link?.blank === 'Yes' ? '_blank' : '_self'),
        linkRel: () => (content?.link ? content?.link?.rel : ''),
        linkTitle: () => (content?.link ? content?.link?.title : '')
      }
      return texts[key]()
    },
    getClass() {
      const {columns} = this
      let totalColumns = 0

      columns.forEach(element => {
        if (element.size === 'double') {
          totalColumns += 2
        } else {
          totalColumns++
        }
      })
      return {
        'has-two-columns': totalColumns === 2,
        'has-three-columns': totalColumns === 3,
        'has-four-columns': totalColumns === 4
      }
    }
  }
}
